import * as React from 'react';
import { MatchingRule, MatchingBrandData } from 'lib/types';
import RecordHome from 'lib/RecordHome';
import { Button, ButtonGroup, DataTable, DataTableColumn, Icon } from '@salesforce/design-system-react';
import { withBrandData } from 'lib/withBrand';

interface RuleHomeProps {
	brandData: MatchingBrandData;
	editModal: JSX.Element | null;
	editRule: () => void;
	navBack: () => void;
	rule: MatchingRule;
}

const RuleHome: React.SFC<RuleHomeProps> = ({ brandData, editModal, editRule, navBack, rule }) => {
	const details = [
		{ label: 'Description', content: rule.description, truncate: true },
		{ label: 'Status', content: rule.status },
		{ label: 'Last Modified', content: rule.lastModified }
	];

	const buttons = (
		<div style={{height: '30px'}}>
			<ButtonGroup className="slds-m-right_small">
				<Button label="Edit" onClick={editRule} />
				<Button label="Delete" />
				<Button label="Clone" />
			</ButtonGroup>
			<Button label="Activate" variant="brand" />
		</div>
	);
	
	const helpIcon = (
		<Icon
			category="utility"
			className="matching-rules_table-header-help"
			name="info"
			size="x-small"
			style={{fill: '#3e3e3c'}}
		/>
	);

	return (
		<div className="matching-rules">
			<RecordHome
				buttons={buttons}
				details={details}
				page={<a href="javascript:void(0);" onClick={navBack}>Matching Rules</a>}
				title={rule.name}
			/>
			<div className="matching-rules_rule-details slds-m-top_small slds-box">
				<h2 className="slds-text-heading_small"><strong>Matching Criteria</strong></h2>
				<DataTable id="matching-rule_criteria" items={brandData.ruleCriteria}>
					<DataTableColumn key="entity" label="Entity" property="entity" />
					<DataTableColumn key="attribute" label="Attribute" property="attribute" />
					<DataTableColumn key="method" label={<span>Matching Method {helpIcon}</span>} property="method" />
					<DataTableColumn key="fuzziness" label={<span>Fuzziness {helpIcon}</span>} property="fuzziness" />
					<DataTableColumn key="blanks" label={<span>Match Blank Fields {helpIcon}</span>} property="blanks" />
				</DataTable>
				<h2 className="slds-text-heading_small"><strong>Matching Logic</strong></h2>
				<p>All of the conditions are met (AND)</p>
			</div>
			{editModal}
		</div>
	);
};

export default withBrandData('matching', RuleHome);


// WEBPACK FOOTER //
// ./src/MatchingRules/rule-home.tsx